export default __webpack_public_path__ + "static/media/ic_download.80108963.svg";